module.exports = __webpack_public_path__ + "img/communications.68476910.png";